export const REQUEST_ACCESS_TOKEN = 'requestAccessToken';
export const SET_TITLE = 'setTitle';
export const GET_URL = 'getUrl';
export const LOGOUT = 'logout';
export const GET_LANGUAGE = 'getLanguage';
